import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { Daily } from "./Daily";
import { Weekly } from "./Weekly";
import { themes } from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { setShowShiftBack } from "services/Redux/TeamZone";
import { setPlanShiftScreen } from "services/Redux/TeamZone";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { startOfMonth, endOfMonth } from "date-fns";
import moment from "moment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { showToast } from "services/utils/Status";
// import { useFetch } from "services/hooks/useFetch";
import sessionHandling from "services/utils/notificationUtils";
import { Monthly } from "./Monthly";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import dayjs from "dayjs";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomToggleButton } from "components/CustomComponents/CustomToggleButton";

export const PlanShift = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const { showShiftBack } = useSelector((state) => state.teamZoneReducer);
  // const { result: departmentData } = useFetch(
  //   `${domain}get-department/?user_id=${userDetails.id}`
  // );
  const [departmentIdValue, setDepartmentIdValue] = useState(departmentId);
  const [departmentNames, setDepartmentName] = useState(departmentName);
  const [dataVisualMethod, setDataVisualMethod] = useState("Daily");
  const [alignment, setAlignment] = useState("Daily");
  const [workUnitCheck, setWorkUnitCheck] = useState(false);
  // const [lastViewedScreens, setLastViewedScreens] = useState("Daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [listOfDate, setListOfDate] = useState([]);
  const [selectCurrentDate, setSelectCurrentDate] = useState(dayjs());
  const [monthlyselectedDate, setMonthlySelectedDate] = useState(new Date());
  const [formattedDate, setFormattedDate] = useState(new Date(), "yyyy-MM");
  const [loading, isLoading] = useState(false);
  const [fetchWeekly, setFetchWeekly] = useState(true);
  const [presentScreen, setPresentScreen] = useState(false);
  const [weeklyShiftList, setWeeklyShiftList] = useState([]);
  const [monthlyShiftList, setMonthlyShiftList] = useState([]);
  const [dailyShiftList, setDailyShiftList] = useState([]);
  const [filterChanges, setFilterChanges] = useState(false);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const minDate = new Date(2020, 0, 1);
  const [shiftGrpError, setGrpNameError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [calculateInnerWidth, setCalculateInnerWidth] = useState(
    window.innerWidth < 1400
  );
  const [departmentData, setDepartmentData] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setCalculateInnerWidth(window.innerWidth < 1400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (topbarCompanyId) {
      setFetchWeekly(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const departmentDataWithLabel = res.map((obj) => ({
            ...obj,
            label: obj.department_name,
          }));
          const allDepartment = {
            id: 99999,
            label: "All",
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...departmentDataWithLabel]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [departmentId, domain, token, userDetails.id]);

  useEffect(() => {
    if (presentScreen !== true && departmentData?.length !== 0 && !loadData) {
      // setDepartmentIdValue(departmentId);
      let filterData = departmentData.filter((data) => {
        return data.department_name === departmentNames;
      });
      // setDepartmentName(departmentNames);
      setWorkUnitCheck(
        departmentNames === "All"
          ? departmentData
            ? departmentData[0]?.work_unit
            : false
          : filterData
          ? filterData[0]?.work_unit
          : false
      );
      setLoadData(true);
    }
  }, [
    dataVisualMethod,
    departmentData,
    departmentId,
    departmentNames,
    dispatch,
    loadData,
    presentScreen,
  ]);

  const getCurrentWeek = () => moment().format("GGGG-[W]WW");

  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek);

  const getWeekDays = (startDate) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(startDate);
      day.setDate(startDate.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const handleDateOnChange = (value) => {
    setPresentScreen(true);
    setSelectCurrentDate(value);
    setFetchWeekly(true);
  };

  const handleMonthlyDateOnChange = (date) => {
    if (
      date instanceof Date &&
      !isNaN(date) &&
      date.getFullYear().toString().length === 4 &&
      date >= minDate
    ) {
      setPresentScreen(true);
      setMonthlySelectedDate(date);
    } else if (date.getFullYear().toString().length === 4 && date < minDate) {
      showToast("error", "Year must be 01/01/2020 or later");
    }
  };

  const handleWeeklyDateOnChange = (event) => {
    setSelectedWeek(event.target.value);
  };
  //  && departmentIdValue !== 99999
  useEffect(() => {
    if (selectedWeek && dataVisualMethod) {
      if (dataVisualMethod === "Weekly") {
        const startDate = moment(selectedWeek).startOf("isoWeek").toDate();
        const endDate = moment(selectedWeek).endOf("isoWeek").toDate();
        const dates = getWeekDays(startDate);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD")
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(startDate).format("YYYY-MM-DD"));
        setEndDate(moment(endDate).format("YYYY-MM-DD"));
        if (startDate !== "" && endDate !== "") {
          setFetchWeekly(true);
        }
      } else if (
        selectCurrentDate &&
        departmentIdValue !== 99999 &&
        dataVisualMethod === "Daily"
      ) {
        if (startDate !== "") {
          setFetchWeekly(true);
        }
      } else {
        const start = startOfMonth(monthlyselectedDate);
        const end = endOfMonth(monthlyselectedDate);
        const dates = getMonthDays(start);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD")
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(start).format("YYYY-MM-DD"));
        setEndDate(moment(end).format("YYYY-MM-DD"));
        if (start !== "" && end !== "") {
          setFetchWeekly(true);
        }
      }
    }
  }, [
    dataVisualMethod,
    departmentIdValue,
    monthlyselectedDate,
    selectCurrentDate,
    selectedWeek,
    startDate,
  ]);

  const getMonthDays = (startDate) => {
    const days = [];
    const year = startDate.getFullYear();
    const month = startDate.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let currentDate = firstDayOfMonth;

    while (currentDate <= lastDayOfMonth) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return days;
  };

  useEffect(() => {
    const formatDate = () => {
      if (monthlyselectedDate) {
        const formattedDate =
          monthlyselectedDate?.getFullYear() +
          "-" +
          ("0" + (monthlyselectedDate?.getMonth() + 1)).slice(-2);
        setFormattedDate(formattedDate);
      }
    };
    formatDate();
    if (
      formattedDate &&
      departmentIdValue !== 99999 &&
      dataVisualMethod === "Monthly"
    ) {
      setFetchWeekly(true);
    }
  }, [dataVisualMethod, departmentIdValue, formattedDate, monthlyselectedDate]);

  const updateShiftBasedOnRange = async (userId, shift_assignments) => {
    try {
      const response = await fetch(`${domain}shift_assignments/daily/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          shift_assignments: [
            {
              user: userId,
              daily_assignments: shift_assignments,
            },
          ],
        }),
      });
      const res = await response.json();
      if (response.ok) {
        showToast("success", "Shift assigned successfully");
        setFetchWeekly(true);
        setOpenDialog(false);
        setGrpNameError(false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };

  useEffect(() => {
    const fetchWeeklyShiftList = async () => {
      isLoading(true);
      const formattedDate = dayjs(selectCurrentDate).format("YYYY-MM-DD");
      try {
        let url =
          dataVisualMethod === "Daily"
            ? `${domain}daily_user_shift_assignments/?department_id=${departmentIdValue}&from_date=${formattedDate}&to_date=${formattedDate}&user_id=${userDetails?.id}&company_id=${topbarCompanyId}`
            : `${domain}daily_user_shift_assignments/?department_id=${departmentIdValue}&from_date=${startDate}&to_date=${endDate}&user_id=${userDetails?.id}&company_id=${topbarCompanyId}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          setMasterDataForSearch([]);
          dataVisualMethod === "Monthly"
            ? setMonthlyShiftList([])
            : setWeeklyShiftList([]);
          dataVisualMethod === "Daily" && setDailyShiftList(res?.data);
          dataVisualMethod === "Monthly"
            ? setMonthlyShiftList(res?.data)
            : setWeeklyShiftList(res?.data);

          setMasterDataForSearch(res?.data);
          isLoading(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
        isLoading(false);
      }
    };
    if (fetchWeekly && departmentIdValue !== "" && loadData) {
      fetchWeeklyShiftList();
      setFetchWeekly(false);
    }
  }, [
    dataVisualMethod,
    departmentIdValue,
    domain,
    endDate,
    fetchWeekly,
    loadData,
    selectCurrentDate,
    startDate,
    token,
    topbarCompanyId,
    userDetails?.id,
  ]);

  useEffect(() => {
    const FilterDailyShiftData = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setDailyShiftList(FilterDailyShiftData());
    setFilterChanges(true);
  }, [globalSearchValue, masterDataForSearch]);

  useEffect(() => {
    const FilterWeeklyShiftData = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setWeeklyShiftList(FilterWeeklyShiftData());
    setFilterChanges(true);
  }, [globalSearchValue, masterDataForSearch]);

  useEffect(() => {
    const FilterMonthlyShiftData = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setMonthlyShiftList(FilterMonthlyShiftData());
    setFilterChanges(true);
  }, [globalSearchValue, masterDataForSearch]);

  const updateDepartmentName = (event, data) => {
    if (data) {
      setDepartmentIdValue(data.id);
      setDepartmentName(data.department_name);
      setWorkUnitCheck(data?.work_unit);
      setFetchWeekly(true);
    }
  };

  const renderComponent = () => {
    switch (dataVisualMethod) {
      case "Daily":
        return (
          <Daily
            dailyShiftList={dailyShiftList}
            loading={loading}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            updateDailyShift={updateShiftBasedOnRange}
            selectCurrentDate={selectCurrentDate}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            setDepartmentIdValue={setDepartmentIdValue}
            setFetchWeekly={setFetchWeekly}
            workUnitCheck={workUnitCheck}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      case "Monthly":
        return (
          <Monthly
            loading={loading}
            isLoading={isLoading}
            monthlyShiftList={monthlyShiftList}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            listOfDate={listOfDate}
            updateMonthlyShift={updateShiftBasedOnRange}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      case "Weekly":
        return (
          <Weekly
            loading={loading}
            weeklyShiftList={weeklyShiftList}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            listOfDate={listOfDate}
            updateWeeklyShift={updateShiftBasedOnRange}
            setFetchWeekly={setFetchWeekly}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            workUnitCheck={workUnitCheck}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      // case "MoveShiftGroup":
      //   return (
      //     <MoveShiftGroup
      //       lastViewedScreens={lastViewedScreens}
      //       setDataVisualMethod={setDataVisualMethod}
      //       reCallApi={setLoadData}
      //     />
      //   );
      default:
        break;
    }
  };

  const buttons = [
    {
      value: "Daily",
      label: "Daily",
      onClick: () => {
        isLoading(true);
        setPresentScreen(true);
        setFetchWeekly(true);
        setSelectedWeek(getCurrentWeek);
        setDataVisualMethod("Daily");
        // setLastViewedScreens("Daily");
        dispatch(setPlanShiftScreen("Daily"));
        localStorage.setItem("planShiftScreen", "Daily");
      },
    },
    {
      value: "Weekly",
      label: "Weekly",
      onClick: () => {
        isLoading(true);
        setPresentScreen(true);
        setSelectedWeek(getCurrentWeek);
        setDataVisualMethod("Weekly");
        // setLastViewedScreens("Weekly");
        dispatch(setPlanShiftScreen("Weekly"));
        localStorage.setItem("planShiftScreen", "Weekly");
      },
    },
    {
      value: "Monthly",
      label: "Monthly",
      onClick: () => {
        isLoading(true);
        setPresentScreen(true);
        setDataVisualMethod("Monthly");
        // setLastViewedScreens("Monthly");
        dispatch(setPlanShiftScreen("Monthly"));
        localStorage.setItem("planShiftScreen", "Monthly");
      },
    },
  ];

  // return departmentNames === "All" ? (
  //   <Loader info="Loading..." />
  // ) : (
  return (
    <React.Fragment>
      {/* {dataVisualMethod === "MoveShiftGroup" ? null : ( */}
      <>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          {showShiftBack ? (
            <BackArrow
              actionFunction={() => {
                dispatch(setGlobalSearchValue(""));
                history.push("/admin/shift");
                dispatch(setShowShiftBack(false));
              }}
            />
          ) : null}
          <Mui.Grid xs={2}>
            <Mui.Typography>Select department name</Mui.Typography>
            <CustomAutoComplete
              dataList={departmentData?.map((obj) => ({
                ...obj,
                label: obj.department_name,
              }))}
              selectedValue={departmentNames}
              updateDataFunction={updateDepartmentName}
              placeHolder="Select department name"
              // label="Select Department Name"
            />
          </Mui.Grid>
          <Mui.Grid xs={calculateInnerWidth ? 7.9 : 7.9}></Mui.Grid>
          <Mui.Grid xs={calculateInnerWidth ? 2 : 2}>
            <Mui.Stack>
              {dataVisualMethod === "Daily" ? (
                <Mui.Typography>Select Date</Mui.Typography>
              ) : dataVisualMethod === "Monthly" ? (
                <Mui.Typography>Select Month</Mui.Typography>
              ) : (
                <Mui.Typography>Select Week</Mui.Typography>
              )}
              {dataVisualMethod === "Daily" ? (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <div sx={{ width: 4 }}>
                      <DatePicker
                        size="small"
                        slotProps={{ textField: { size: "small" } }}
                        sx={{ minWidth: "100%" }}
                        value={selectCurrentDate}
                        format="DD/MM/YYYY"
                        onChange={handleDateOnChange}
                        renderInput={(params) => (
                          <Mui.TextField {...params} size="small" />
                        )}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              ) : dataVisualMethod === "Monthly" ? (
                <Mui.Stack>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={["year", "month"]}
                      size="small"
                      sx={{ minWidth: "100%" }}
                      value={monthlyselectedDate}
                      minDate={minDate}
                      onChange={handleMonthlyDateOnChange}
                      slotProps={{ textField: { size: "small" } }}
                      renderInput={(params) => (
                        <Mui.TextField {...params} size="small" />
                      )}
                    />
                  </LocalizationProvider>
                </Mui.Stack>
              ) : (
                <Mui.TextField
                  type="week"
                  value={selectedWeek}
                  size="small"
                  sx={{ minWidth: "100%" }}
                  onChange={handleWeeklyDateOnChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </Mui.Stack>
          </Mui.Grid>
          <Mui.Grid
            xs={calculateInnerWidth ? 2 : 1.5}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingBottom: 0.5,
            }}
          >
            {/* <Mui.Button
                variant={"contained"}
                sx={{
                  background: themes.primaryButton,
                  textTransform: "capitalize",
                  mr: 2,
                  border: "none",
                  "&:hover": {
                    border: "none",
                    backgroundColor: themes.primaryButton,
                  },
                  color: themes.headLine,
                }}
                onClick={() => {
                  setDataVisualMethod("MoveShiftGroup");
                  // history.push("/admin/teamzone/shift-group");
                  dispatch(setGlobalSearchValue(""));
                }}
              >
                Change Shift Group
              </Mui.Button> */}
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container sx={{ paddingTop: 1 }}>
          <CustomToggleButton
            alignment={alignment}
            handleChange={(_, newVal) => newVal && setAlignment(newVal)}
            buttons={buttons}
            themes={themes}
          />
        </Mui.Grid>
      </>
      {/* )} */}
      <Mui.Grid>{renderComponent()}</Mui.Grid>
    </React.Fragment>
  );
};
